import React, { useState, useEffect } from "react";

const ViewSiteImageModel = ({ isOpenModal, data, onClose }) => {
  const [currentImage, setCurrentImage] = useState(null);
  const [addresses, setAddresses] = useState({}); // store fetched addresses
  console.log("data in model", data);

  useEffect(() => {
    if (data && data.length > 0) {
      data.forEach((item, index) => {
        if (item.coordinates) {
          const [lat, lng] = item.coordinates.split(",").map(Number);

          fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
          )
            .then((res) => res.json())
            .then((resData) => {
              setAddresses((prev) => ({
                ...prev,
                [index]: resData.display_name || "Address not available",
              }));
            })
            .catch(() => {
              setAddresses((prev) => ({
                ...prev,
                [index]: "Address not available",
              }));
            });
        }
      });
    }
  }, [data]);

  if (!isOpenModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-end z-50">
      <div className="w-[780px] h-full bg-white p-3 shadow-lg relative flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-3 border-b pb-4">
          <h2 className="text-lg font-semibold">Site Visit Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 p-2 hover:text-gray-800 text-xl"
          >
            &times;
          </button>
        </div>

        {/* Content */}
        <div className="mt-4 flex flex-col gap-6 overflow-y-auto custom-scrollbar px-2 flex-grow">
          {data && data.length > 0 ? (
            data.map((item, index) => {
              let lat, lng;
              if (item.coordinates) {
                [lat, lng] = item.coordinates.split(",").map(Number);
              }

              return (
                <div
                  key={index}
                  className="shadow-md rounded-md p-3 flex gap-4 border pb-4"
                >
                  {/* Left Side - Property Image & Info */}
                  <div className="flex-1 flex flex-col items-center gap-2">
                    <img
                      src={item.image[0]}
                      alt=""
                      className="w-full h-80 object-cover rounded-lg cursor-pointer"
                      onClick={() => setCurrentImage(item.image[0])}
                    />

                    <div className="text-start text-sm text-gray-700 w-full px-2">
                      <div>
                        <span className="font-medium">
                          {item.propertyName || "Unknown Property"}
                        </span>{" "}
                        - {item.visitTime}
                      </div>
                      <div>By {item.visitGivenBy || "Unknown"}</div>
                    </div>
                  </div>

                  {/* Right Side - Map & Address */}
                  <div className="flex-1 flex flex-col items-center gap-2">
                    {lat && lng && (
                      <iframe
                        title={`map-${index}`}
                        src={`https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
                        className="w-full h-80 rounded-md border"
                        allowFullScreen
                        loading="lazy"
                      ></iframe>
                    )}

                    <div className="text-sm text-gray-600 px-2">
                      <span className="font-medium">Address:</span>{" "}
                      {addresses[index] || "Fetching address..."}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center">No images available</div>
          )}
        </div>
      </div>

      {/* Fullscreen Preview */}
      {currentImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="relative bg-white p-4 rounded-lg shadow-lg">
            <button
              onClick={() => setCurrentImage(null)}
              className="absolute top-2 right-2 bg-black rounded-full px-2 text-center text-white text-2xl"
            >
              &times;
            </button>
            <img
              src={currentImage}
              alt="Preview"
              className="max-w-full max-h-[80vh] rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewSiteImageModel;
